import React, { Component } from 'react';

import Parameter from './Parameter';

class APICard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            resultVisisble: true,
            result: {
                'date': 'Sun, 04 Mar 2018 12:13:23 GMT',
                'content-type': "application/json",
                'content-length': "251",
                'connection': "keep-alive",
                'set-cookie': ["AWSALB=ebmgyqAIqcB0TLi6MQQorPKb3UDPoLePNav6+IUWovVeVOi5tu+A46P3QD8YIGOkIU+AH7pEt+fiD+TwvVOKa4DMnfaJ4y4mhWejqJPt/Q793PkA7KpVJgWz5FLV; Expires=Sun, 11 Mar 2018 12:13:23 GMT; Path=/"],
                'server': 'nginx',
                'x-powered-by': "PHP/5.6.31-4+ubuntu16.04.1+deb.sury.org+4",
                'access-control-allow-origin': "*"
            },
            paramValue: {}
        }
    }

    renderResult() {

        return (
            <div className="response" id="show_post">
                <h5>Call:</h5>
                <div className="block-call">
                    {this.renderQuery()}
                </div>
                <h5>Response Code:</h5>
                <div className="block-code">
                    200
                                        </div>
                <h5>Response Header:</h5>
                <div className="block response-header">
                    <pre className="language-json">
                        {`${this.state.result}`}
                    </pre>
                </div>
                <h5>Response Body:</h5>
                <div className="block response-body">
                    <pre>
                        <code className="language-json">
                            {`"success": false,
                                            "response": null,
                                            "error_code": "0903",
                                            "message": "Invalid parameter , [ api_key , token ] require , must not be blank or special character",
                                            "timestamp": 1520165944,
                                            "time": "Sun, 04 Mar 2018 19:19:04 +0700 Asia/Bangkok",
                                            "version": "2.32.0"
                                        `}
                        </code>
                    </pre>
                </div>
            </div>
        );
    }

    onTryOutClick() {

        this.setState({ resultVisisble: true });

        console.log(this.state.paramValue);
    }

    onClearResultClick() {
        this.setState({ resultVisisble: false });


    }

    onParamValueChange(value, name) {

        // console.log(`${name}: ${value}`);

        const updatedParam = this.state.paramValue;
        updatedParam[name] = value;
        this.setState({ paramValue: updatedParam });
    }

    renderParameters(parameters) {

        const views = parameters.map(param => {
            return (
                <Parameter
                    name={param.name}
                    defaultValue={param.defaultValue}
                    inputType={param.inputType}
                    type={param.type}
                    location={param.location}
                    description={param.description}
                    key={param.name}
                    onValueChange={(value) => this.onParamValueChange(value, param.name)}
                    textInputType={param.textInputType}
                />
            );
        });

        return (
            <tbody>
                {views}
            </tbody>
        );
    }

    renderQuery() {

        const { path, parameters } = this.props.config;

        let query = `${this.props.path}`;
        parameters.map(param => {

        });

        return query;
    }

    render() {
        const { resultVisisble } = this.state;
        const { method = 'GET', name, path, description, id, config } = this.props;
        const classNameSuffix = method.toLowerCase();

        return (
            <div className={`card card-api ${classNameSuffix}`}>
                <div className="card-header" id={id} data-toggle="collapse" data-target={`#collapse${id}`} aria-expanded="false" aria-controls={`collapse${id}`}>
                    <div className="mb-0 justify-content-between card-title">
                        <button className={`btn btn-api btn-${classNameSuffix}`} type="button" name={classNameSuffix}>
                            {method}
                        </button>
                        <p className="name">{name}</p>
                        <span className="path">{path}</span>
                    </div>
                </div>
                <div id={`collapse${id}`} className="collapse" aria-labelledby={id} data-parent={`#collapse${id}`}>
                    <div className="card-body">
                        <p>{description}</p>
                        <form action="">
                            <div className="table-responsive-sm">
                                <table className="table table-list">
                                    <thead>
                                        <tr>
                                            <th scope="col">Parameter</th>
                                            <th scope="col">Value</th>
                                            <th scope="col">Type</th>
                                            <th scope="col">Location</th>
                                            <th scope="col">Description</th>
                                        </tr>
                                    </thead>
                                    {this.renderParameters(config.parameters)}
                                </table>
                            </div>
                            <div className="card-link justify-content-between">
                                <button className="btn btn-api btn-try has-spinner" name="try" type="button" onClick={this.onTryOutClick.bind(this)}>
                                    {`Try it out!`}
                                </button>
                                <button className="btn btn-link" type="button" onClick={this.onClearResultClick.bind(this)} id="clear_post">
                                    {`Clear Results`}
                                </button>
                            </div>
                        </form>
                        {resultVisisble ? this.renderResult() : null}
                    </div>
                </div>
            </div>
        );
    }
}

export default APICard;



// WEBPACK FOOTER //
// ./src/views/components/APICard.jsx